// extracted by mini-css-extract-plugin
export var orderSummary = "_lo-0";
export var showMoreLessButton = "_lo-1";